import React, { useEffect, useState } from 'react'
import './index.scss';
import Text, { TYPES as types, SIZES as sizes } from 'components/elements/Text'
import Input from 'components/elements/input'
import CheckBox from '../CheckBoxNew';
import Button, { SIZES as btnSizes } from 'components/elements/Button'
import IconNew from '../iconsSize';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { QueryForm } from 'utils/Query';
import { Login, RegisterEmailVerify, RegisterResendEmail, RegisterStepOne, RegisterStepTwo, ResetPasswordSend } from 'api/AuthApi';
import Select from '../Select';
import Line from '../Line';
import CheckboxCircle from '../CheckboxCircle';
import { isPrint } from 'utils/copy';
import { toast } from 'react-toastify';
import memberLoader from './memberLoader.svg';
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const openGoogleLogin = () => {
    //window.open(`${window.location.origin}/social/redirectToProviderGoogle`)
    window.open(`${window.location.protocol}//${window.location.hostname}/redirectToProviderGoogle`)
    // window.location.href = `https://miestro.com/redirectToProviderGoogle`;
}

export const LogInInputs = ({ onSignUp, onForgetPassword }) => {
    const navigate = useNavigate();
    const [inputs, setInputs] = React.useState({
        password: '',
        email: '',
        isRemember: false,
    })

    // const { executeRecaptcha } = useGoogleReCaptcha();

    const [query, { loading }] = QueryForm(Login)

    useEffect(() => {
        const listener = event => {
          if ((event.code === "Enter" || event.keyCode=== 13) && inputs.email &&  inputs.password) {
            onSumbit(event);
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[inputs]);

    const onSumbit = (e) => {
        e.preventDefault();

        // if(!executeRecaptcha) {
        //     console.log("Execute recaptcha not yet available");
        //     return;
        // }

        // executeRecaptcha("loginFormSubmit").then((token) => {
            query({...inputs}, (token) => {
                // window.open(token)
                window.location = token;
            })

        // })
    }

    const handleInputChange = (name, value) => {
        setInputs({
            ...inputs,
            [name]: value
        })
    }

    const navigateToSignUp = () => {
        navigate('/signup');
    }

    const navigateToForgot = () => {
        navigate('/forgot-password')
    }

    return (
        <div className='flex flex-col gap-6 mt-[auto] mb-[auto] w-[400px] max-w-[100%]'>
            {loading && <div className='freezing_login'>
                <div className='freezing_content_login'>
                    <img src={ memberLoader } width={ 120 } height={ 120 } alt='loader' />
                </div>
            </div>}
            <div className="flex flex-col gap-3">
                <Text
                    inner='Login With Your Email'
                    type={types.mediumSmall}
                    size={sizes.xxlarge}
                />
                <div className="flex gap-1">
                    <Text
                        inner="Don't have an account?"
                        type={types.regular148}
                        size={sizes.small}
                        style={{ color: '#444C4B' }}
                    />
                    <span onClick={navigateToSignUp} className='hover:bg-[#E8F2F1] ease-in duration-200 rounded-[12px]'>
                        <Text
                            inner="Sign Up"
                            style={{ cursor: 'pointer', color: '#24554E', padding: '6px 8px' }}
                            type={types.medium}
                            size={sizes.small}
                            // onClick={() => onSignUp()}
                        />
                    </span>
                </div>
                <div className="flex flex-col gap-3">
                    <Input
                        name='email'
                        placeholder='Your email address'
                        label='Email'
                        value={inputs.email}
                        onChange={handleInputChange}
                        style={{padding: '10px 16px'}}
                    />
                    <Input
                        name='password'
                        isPassword={true}
                        type='password'
                        placeholder='Enter your password'
                        label='Password'
                        value={inputs.password}
                        onChange={handleInputChange}
                    />
                    <div className="mt-1 flex items-start justify-between">
                        <CheckBox
                            name='isRemember'
                            label='Remember me'
                            labelPosition='right'
                            checked={inputs.isRemember}
                            onChange={handleInputChange}
                        />
                        <span className='hover:bg-[#E8F2F1] ease-in duration-200 rounded-[12px]'>
                            <Text
                                inner='Forgot Password'
                                type={types.medium}
                                onClick={navigateToForgot}
                                size={sizes.small}
                                style={{ color: '#24554E', cursor: 'pointer', padding: '6px 8px' }}
                            />
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-3">
                <Button
                    text='Login'
                    disabled={!inputs.email || !inputs.password || loading}
                    onClick={(e) => onSumbit(e)}
                    size={ btnSizes.large50 }
                    theme='custom_style'
                />
            </div>
            <div className="flex gap-4 items-center">
                <div className="w-full h-[1px]" style={{ background: '#E7E9E9' }}></div>
                <Text
                    inner="or"
                    type={types.regularDefault}
                    style={{ color: '#727978' }}
                    size={sizes.small}
                />
                <div className="w-full h-[1px]" style={{ background: '#E7E9E9' }}></div>
            </div>

               <div className="hover:bg-[#E8F2F1] ease-in duration-200 google__button" role='presentation' onClick={() => openGoogleLogin()}>
                <IconNew name='GoogleSvgM' />
                <Text
                    inner='Login With Google'
                    type={types.mediumLarge}
                    size={sizes.small}
                    style={{ color: '#24554E' }}
                />
            </div>
        </div>
    )
}


export const SignUpInputs = ({ onSignin, onLoadingChange }) => {
    const navigate = useNavigate()
    const [step, setStep] = React.useState(1)
    const [stepOneQuery, { loading }] = QueryForm(RegisterStepOne)
    const [stepTwoQuery, { loading: stepTwoLoading }] = QueryForm(RegisterStepTwo)
    const [verifyQuery, { loading: verifyLoading }] = QueryForm(RegisterEmailVerify)
    const [resendCode, { loading: resendCodeLoading }] = QueryForm(RegisterResendEmail)
    const [uuid, setUuid] = useState(null);
    const { state } = useLocation();
    const [inputs, setInputs] = React.useState({
        password: '',
        email: '',
        name: '',
        agree: true,
        // phone: '',
    })
    useEffect(() => {
        const script = document.createElement('script');
        script.innerHTML = `fbq('track', 'PageView');`;
        document.head.appendChild(script);
        return () => {
          document.head.removeChild(script);
        };
      }, []);

    useEffect(() => {
        onLoadingChange(loading)

        // eslint-disable-next-line
    }, [loading])

    const handleInputChange = (name, value) => {
        setInputs({
            ...inputs,
            [name]: value
        })
    }

    // const { executeRecaptcha } = useGoogleReCaptcha();

    useEffect(() => {
        const listener = event => {
          if ((event.code === "Enter" || event.keyCode=== 13)  &&  (inputs.email && inputs.agree && inputs.password && !loading)) {
            handleFirstStep();
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[inputs,loading]);

    const handleFirstStep = () => {

        // if(!executeRecaptcha) {
        //     console.log("Execute recaptcha not yet available");
        //     return;
        // }

        // executeRecaptcha("registrationFormSubmit").then((token) => {
            const data= {
                ...inputs,
                plan_id: state?.plan_id ? state.plan_id : 'newmiestro-essential-plan-monthly'

                // 'g-recaptcha-response': token
            }
            const searchParams = new URLSearchParams(document.location.search)
            if(Boolean(searchParams.get('ref'))) {
                data.default_ref_id = searchParams.get('ref')
            }
            stepOneQuery(data, (e) => {
                window.location.href = e.url
                // if (e.uuid) {
                //     setStep(2)
                //     setUuid(e.uuid)
                //     setInputs({
                //         question_1: '',
                //         question_2: 'Create A New Online Training',
                //         question_3: 'Yes',
                //         email: inputs.email,
                //         uuid: e.uuid
                //     })
                // }
            })

        // })

    }

    const handleSecondStep = () => {
        stepTwoQuery({
            question_1: inputs.question_1,
            question_2: inputs.question_2,
            question_3: inputs.question_3,
            uuid
        }, (e) => {
            window.location.href = e.url
            // if (isPrint('Code sent to email successfully')) {
            //     toast.success('Code sent to email successfully')
            // }
           // setStep(3)
            setInputs({
                code: '',
                email: inputs.email,
                uuid: inputs.uuid,
            })
        })
    }

    const handleSendCode = () => {
        verifyQuery({
            email: inputs.email,
            uuid: inputs.uuid,
            verify_code: inputs.code
        }, (data) => {
            window.location.href = data.url
        })
    }

    const handleResendCode = () => {
        resendCode({
            email: inputs.email,
        }, () => {
            if (isPrint('Code sent to email successfully')) {
                toast.success('Code sent to email successfully')
            }
        })
    }

    const helpOptions = [
        { label: 'Create A New Online Training', value: 'Create A New Online Training' },
        { label: 'Scale My Current Online Training', value: 'Scale My Current Online Training' },
        { label: 'Help With Training Employees', value: 'Help With Training Employees' },
    ]
    if (step === 3) {
        return (
            <div className='flex mt-[auto] mb-[auto] flex-col sign_up_form gap-6 justify-between'>
                <div className="progress__line">
                    <div className="progress__line__completed" style={{ width: '66%' }}></div>
                </div>
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-3">
                        <Text
                            inner='Email Verification'
                            type={types.mediumSmall}
                            size={sizes.xxlarge}
                        />
                        <Text
                            inner='The email verification code has been sent to your email address.'
                            type={types.regular148}
                            size={sizes.medium}
                        />
                    </div>
                    <div className="flex flex-col gap-3">
                        <Input
                            name='code'
                            placeholder='Enter your verification code'
                            helpText='Prerequisite'
                            label='Verification Code?'
                            value={inputs.code}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="flex justify-end">
                    <Text
                        inner='Resend Code'
                        onClick={resendCodeLoading ? () => { } : () => handleResendCode()}
                        type={types.mediumLarge}
                        size={sizes.small}
                        style={{ color: '#24554E', cursor: 'pointer' }}
                    />
                </div>
                <div className="flex flex-col gap-3">
                    <Button
                        text='Confirm & Start Your Free Trial'
                        loading={verifyLoading}
                        disabled={verifyLoading || !inputs.code}
                        onClick={() => handleSendCode()}
                    />
                </div>
            </div>
        )
    }
    if (step === 2) {
        return (
            <div className='flex mt-[auto] mb-[auto] sign_up_form flex-col gap-6 justify-between'>
                <div className="progress__line">
                    <div className="progress__line__completed" style={{ width: '33%' }}></div>
                </div>
                <div className="flex flex-col gap-3">
                    <Text
                        inner='We Have a Few Questions Below to Customize Your Miestro Experience'
                        type={types.mediumSmall}
                        size={sizes.xxlarge}
                    />
                    <div className="flex flex-col gap-3">
                        <Input
                            name='question_1'
                            placeholder='Enter company name'
                            helpText='Prerequisite'
                            label='What is the name of your company?'
                            value={inputs.question_1}
                            onChange={handleInputChange}
                        />
                        <Select
                            options={helpOptions}
                            value={inputs.question_2}
                            type='select-medium'
                            label='How will Miestro help you?'
                            name='question_2'
                            onChange={handleInputChange}
                        />
                        <Line />
                        <div className="flex flex-col gap-2">
                            <Text
                                inner='Are you switching from another provider?'
                                type={types.regularDefault}
                                size={sizes.small}
                            />
                            <div className="flex gap-6">
                                <CheckboxCircle
                                    isChecked={inputs.question_3 === 'Yes'}
                                    label='Yes'
                                    onCheck={() => handleInputChange('question_3', 'Yes')}
                                />
                                <CheckboxCircle
                                    isChecked={inputs.question_3 === 'No'}
                                    label='No'
                                    onCheck={() => handleInputChange('question_3', 'No')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-3">
                    <Button
                        text='Confirm & Start Your Free Trial'
                        disabled={stepTwoLoading}
                        loading={stepTwoLoading}
                        onClick={() => handleSecondStep()}
                    />
                </div>
            </div>
        )
    }

    const handleNavigateToLogin = () => {
        navigate('/login');
    }

    return (
        <>
        {loading && <div className='freezing'>
            <div className='freezing_content'>
                 Please Wait While Your Miestro Account Is Being Set Up!
            </div>
        </div>}


        <div className='flex flex-col gap-6  sign_up_form mt-[auto] mb-[auto]  w-[400px] max-w-[100%]'>
            <div className="progress__line">
                <div className="progress__line__completed" style={{ width: '0%' }}></div>
            </div>
            <div className="flex flex-col gap-3">
                <div className='flex flex-col'>
                    <Text
                        inner='Create Your Account.'
                        type={types.mediumSmall}
                        size={sizes.xxlarge}
                    />
                    <Text
                        inner='Start Your 14 Trial Today!'
                        type={types.mediumSmall}
                        size={sizes.xxlarge}
                    />
                </div>
                <div className="flex gap-1 ">
                    <Text
                        inner="Already have an account?"
                        type={types.regular160}
                        size={sizes.medium}
                        style={{ color: '#444C4B' }}
                    />
                    <span onClick={handleNavigateToLogin} className='hover:bg-[#E8F2F1] ease-in duration-200 rounded-[12px] '>
                        <Text
                            inner="Login"
                            style={{ cursor: 'pointer', color: '#24554E', padding: '6px 8px', fontWeight: '500' }}
                            type={types.regular160}
                            size={sizes.medium}
                            // onClick={() => onSignin()}
                        />
                    </span>
                </div>
                <div className="flex flex-col gap-3 sign_up_first_inputs">
                    <Input
                        name='name'
                        placeholder='Enter your first and last name'
                        label='Full Name'
                        value={inputs.name}
                        onChange={handleInputChange}
                    />
                    <Input
                        name='email'
                        placeholder='Your email address'
                        label='Email'
                        value={inputs.email}
                        onChange={handleInputChange}
                    />
                    {/* <Input
                        name='phone'
                        type='number'
                        placeholder='Your phone number'
                        label='Phone'
                        value={inputs.phone}
                        onChange={handleInputChange}
                    /> */}
                    <Input
                        name='password'
                        isPassword={true}
                        type='password'
                        placeholder='Enter your password'
                        label='Password'
                        value={inputs.password}
                        onChange={handleInputChange}
                    />
                    {/* <div className="mt-1  flex items-center">
                        <CheckBox
                            name='agree'
                            label='I agree to the'
                            labelPosition='right'
                            checked={inputs.agree}
                            onChange={handleInputChange}
                        />
                        <NavLink
                            to="/information/privacy"
                            target="_blank"
                        >
                            <Text
                                inner='Terms of Use'
                                type={types.mediumLarge}
                                size={sizes.small}
                                style={{ color: '#24554E', cursor: 'pointer' }}
                            />
                        </NavLink>

                    </div> */}
                </div>
            </div>
            <div className="flex flex-col gap-3">
                <Button
                    text='Start Free Trial'
                    loading={loading}
                    disabled={!inputs.email || !inputs.password || loading}
                    onClick={() => handleFirstStep()}
                    size={ btnSizes.large50 }
                    theme='custom_style'
                />
                <NavLink
                    to="/information/privacy"
                    target="_blank"
                >
                    <p className='form_footer_text'>
                        By providing your email address and clicking 'Start Free Trial' above, you agree to Miestro's <span>Terms of Service and Privacy Policy.</span> You can change your communication preferences anytime.
                    </p>
                </NavLink>

                {/* <Text
                    inner="By providing your email address and clicking 'Start Free Trial' above, you agree to Miestro's "
                    type={types.regular148}
                    style={{ color: '#727978', lineHeight: '140%' }}
                    size={sizes.xx_small}
                /> */}
            </div>
            <div className="flex gap-4 items-center">
                <div className="w-full h-[1px]" style={{ background: '#E7E9E9' }}></div>
                <Text
                    inner="or"
                    type={types.regularDefault}
                    style={{ color: '#727978' }}
                    size={sizes.small}
                />
                <div className="w-full h-[1px]" style={{ background: '#E7E9E9' }}></div>
            </div>

              <div className="hover:bg-[#E8F2F1] ease-in duration-200 google__button" role='presentation' onClick={() => openGoogleLogin()}>
                <IconNew name='GoogleSvgM' />
                <Text
                    inner='Sign Up With Google'
                    type={types.mediumLarge}
                    size={sizes.small}
                    style={{ color: '#24554E' }}
                />
            </div>
        </div>
        </>
    )
}

export const ForgetPasswordInputs = ({ onSignin, closeModal }) => {
    const navigate = useNavigate();
    const [inputs, setInputs] = React.useState({
        email: '',
    })

    const [query, { loading }] = QueryForm(ResetPasswordSend)

    useEffect(() => {
        const listener = event => {
          if (event.code === "Enter" || event.keyCode=== 13) {
            onSumbit();
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[inputs]);

    const onSumbit = () => {
        query(inputs, () => {
            closeModal()
        })
    }

    const handleInputChange = (name, value) => {
        setInputs({
            ...inputs,
            [name]: value
        })
    }

    const navigateToLogin = () => {
        navigate('/login')
    }

    return (
        <div className='flex flex-col gap-6 mt-[auto] mb-[auto] w-[400px] max-w-[100%]'>
            {loading && <div className='freezing_login'>
                <div className='freezing_content_login'>
                    <img src={ memberLoader } width={ 120 } height={ 120 } alt='loader' />
                </div>
            </div>}
            <div className="flex flex-col gap-3">
                <Text
                    inner='Forgot Password'
                    type={types.mediumSmall}
                    size={sizes.xxlarge}
                />
                <div className="flex gap-1">
                    <Text
                        inner="Already have an account?"
                        type={types.regular148}
                        size={sizes.medium}
                        style={{ color: '#444C4B' }}
                    />
                    <span className='hover:bg-[#E8F2F1] ease-in duration-200 rounded-[12px]'>
                        <Text
                            inner="Login"
                            style={{ cursor: 'pointer', color: '#24554E', padding: '6px 8px' }}
                            type={types.regular148}
                            size={sizes.medium}
                            onClick={navigateToLogin}
                        />
                    </span>
                    {/* stex */}
                </div>
            </div>
            <Input
                name='email'
                placeholder='Your email address'
                label='Email'
                value={inputs.email}
                onChange={handleInputChange}
            />
            <div className="flex flex-col gap-3">
                <Button
                    text='Confirm '
                    disabled={!inputs.email || loading}
                    onClick={() => onSumbit()}
                    theme='custom_style'
                />
                <NavLink
                    to="/information/privacy"
                    target="_blank"
                >
                    <p className='form_footer_text'>
                        By providing your email address and clicking 'Start Free Trial' above, you agree to Miestro's <span>Terms of Service and Privacy Policy.</span> You can change your communication preferences anytime.
                    </p>
                </NavLink>
            </div>
            <div className="flex gap-4 items-center">
                <div className="w-full h-[1px]" style={{ background: '#E7E9E9' }}></div>
                <Text
                    inner="or"
                    type={types.regularDefault}
                    style={{ color: '#727978' }}
                    size={sizes.small}
                />
                <div className="w-full h-[1px]" style={{ background: '#E7E9E9' }}></div>
            </div>

              <div className="hover:bg-[#E8F2F1] ease-in duration-200 google__button" role='presentation' onClick={() => openGoogleLogin()}>
                <IconNew name='GoogleSvgM' />
                <Text
                    inner='Login With Google'
                    type={types.mediumLarge}
                    size={sizes.small}
                    style={{ color: '#24554E' }}
                />
            </div>
        </div>
    )
}
